import React from 'react'
import { Swiper } from 'antd-mobile-v5'
import { useHistory } from 'react-router-dom'

export default function AdsBanner({ bannerList }) {
  const { push } = useHistory()
  const showAd = ({ url }) => {
    if (url.indexOf('/') === 0) {
      push(url)
    } else {
      window.location.href = url
    }
  }

  return (
    <Swiper autoplay loop defaultIndex={Math.floor(Math.random() * (bannerList.length - 1))}>
      {bannerList.map((ad) => (
        <Swiper.Item key={ad.id}>
          <img style={{ width: '100%' }} src={ad.img} alt="ad" onClick={() => showAd(ad)} />
        </Swiper.Item>
      ))}
    </Swiper>
  )
}
